// extracted by mini-css-extract-plugin
module.exports = {"SearchBox":"SearchBox_SearchBox__APn6b","SearchBox--with-button":"SearchBox_SearchBox--with-button__Cj6Sn","input-wrapper":"SearchBox_input-wrapper__GcChi"};